import { styled } from '@linaria/react';
import { bodyFont, fonts, layout, semantic, space } from '../../theme/tokens';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[4]};
  padding-bottom: ${space[4]};
`;

export const ApplyAllRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space[3]};
  padding: ${space[2]} 0;
`;

export const ApplyAllLabel = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.base};
  color: ${semantic.text.primary};
`;

export const Section = styled.section`
  border: 1px solid ${semantic.border.default};
  border-radius: ${layout.borderRadius2xl};
  padding: ${space[4]};
  display: flex;
  flex-direction: column;
  gap: ${space[4]};
`;

export const PlainSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[4]};
`;

export const SectionHeading = styled.h3`
  font-family: ${bodyFont};
  font-size: ${fonts.size.lg};
  font-weight: ${fonts.weight.normal};
  line-height: 1.2;
  color: ${semantic.text.primary};
  margin: 0;
`;

export const OptionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[2]};
`;

export const TimesBlock = styled.div`
  border-top: 1px solid ${semantic.border.default};
  padding-top: ${space[4]};
`;

export const QuantityRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space[4]};
`;

export const QuantityInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[1]};
`;

export const QuantityLabel = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
`;

export const QuantityPrice = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.secondary};
`;
